import React, { Component, Fragment } from "react";
import Select from "react-select";
import { Link } from "react-router-dom";
import Header from "../Header";
import "react-quill/dist/quill.snow.css";
import Quill from "react-quill";
import CategoryModel from "./categoryModal";
import { createCourse } from "../../../services/course";
import { catList } from "../../../services/course";
import AppContext from "../../../contexts/AppContext";

export class CourseCreate extends Component {
    state = {
        item: {     
            category: '',      
            title : '',
            duration : '',
            keywords: '',
            payout: '',
            payout_plus: '',
            description: '',
            image: '',
            video: '',
            status: 'active',
            certificate_title: '',
            popular: false,  
            statusList:[],                 
        },
        createM : false,  
        errors: {},
        tags: [],
        categories: [],
        selectedcat : 'Select',
        selectedFile : '',
        certificateFile: '',
        showCertiDiv : false ,
        selected_status : 'Active',  
    };

    handleStatusSelectChange = selectedOption => {
        let temp = this.state.item;
        temp.status = selectedOption.value;    
        let error = this.state.errors;
        error.status = null;   
        this.setState({ item: temp, errors: error, selected_status:selectedOption.name }); 
    }

    toggleCreate = () => {
        this.setState({ createM: this.state.createM === true ? false : true });
    };

    handleCheck = () => {
        if (this.state.showCertiDiv === true) {
            this.state.item.certificate_title = '';
        }
        this.setState({ showCertiDiv: this.state.showCertiDiv === true ? false : true });
    }

    handlePropCheck = () => {  
        let temp = this.state.item;    
        temp['popular'] = this.state.item.popular === true ? false : true
        this.setState({ item: temp });
    }

    
    listCats = (data) => {        
        let temp = this.state.item;
        let error = this.state.errors;
        temp.category = data[0].value;         
        this.state.selectedcat = data[0].name;  
        error.category = null;   
        this.setState({ item: temp, errors: error, categories: data });  
    }

    
    onChange = field => {
        let temp = this.state.item;
        temp[field.target.name] = field.target.value;       
        let error = this.state.errors;
        error[field.target.name] = null;   
        this.setState({ item: temp, errors: error });
    };

    inputKeyDown = (e) => {
        const val = e.target.value;
        if (e.key === 'Enter' && val) {
            e.preventDefault();
            // Check if tag already exists
            if (this.state.tags.find(tag => tag.toLowerCase() === val.toLowerCase())) {
              return;
            }
            this.setState({ tags: [...this.state.tags, val]});
            this.tagInput.value = null;
        }
        
    };

    removeTag = (i) => {
        const newTags = [ ...this.state.tags ];
        newTags.splice(i, 1);
        this.setState({ tags: newTags });
    }

    handleBlur = field => {
        let temp = this.state.item;
        temp[field.target.name] = field.target.value;
        if(field.target.name == 'payout')
        {
            this.state.item.payout = parseFloat(field.target.value).toFixed(2);
        }
        if(field.target.name == 'payout_plus')
        {
            this.state.item.payout_plus = parseFloat(field.target.value).toFixed(2);
        }
        let error = this.state.errors;
        error[field.target.name] = null;   
        this.setState({ item: temp, errors: error });
    };

    handleQuillChange = value => {
        let temp = this.state.item;
        temp.description = value;

        let error = this.state.errors;
        error.description = null;

        this.setState({ item: temp, errors: error });
    };

    getExtension(filename) {
        let parts = filename.split('.');
        return parts[parts.length - 1];
    }

    isImage(filename) {
        let ext = this.getExtension(filename);
        switch (ext.toLowerCase()) {
          case 'jpg':
          case 'gif':
          case 'bmp':
          case 'png':
            //etc
            return true;
        }
        return false;
    }

    fileChangedHandler = (event) => {
        const file = event.target.files[0];
        this.setState({ selectedFile: file });
    }

    certificateChangedHandler = (event) => {
        const file = event.target.files[0];
        this.setState({ certificateFile: file });
    }

    handlecatSelectChange = selectedOption => {
        let temp = this.state.item;
        temp.category = selectedOption.value;
        let error = this.state.errors;
        error.category = null;   
        this.state.selectedcat = selectedOption.name;         
        this.setState({ item: temp, errors: error,selectedcat:selectedOption.name });
        //console.log(this.state.item,selectedOption.name);
    };

    handleValidation(){
        let fields = this.state.item;
        let errors = {};
        let formIsValid = true;
        let file = this.state.selectedFile;
        let FileSize = file.size / 1024 / 1024; // in MB
        let FileName = file.name;    
        let extensionLists = {}; //Create an object for all extension lists         
        extensionLists.image = ['jpg', 'gif', 'bmp', 'png'];

        let taglist = this.state.tags;

        let cfile = this.state.certificateFile;
        let cFileSize = cfile.size / 1024 / 1024; // in MB
        let cFileName = cfile.name;   

        if(!fields.category){
            formIsValid = false;
            errors.category = "Please select category.";
        }

        if(!fields.title){
            formIsValid = false;
            errors.title = "The title field is required.";
        }
        if(fields.status != "coming_soon" && !fields.duration){
            formIsValid = false;
            errors.duration = "The duration field is required.";
        }
        if(!fields.description){
            formIsValid = false;
            errors.description = "The description field is required.";
        }
        if(!fields.payout){
            formIsValid = false;
            errors.payout = "The basic payout field is required.";
        }

        if(!fields.payout_plus){
            formIsValid = false;
            errors.payout_plus = "The plus payout field is required.";
        }

        if(fields.status != "coming_soon" && taglist.length == 0){
            formIsValid = false;
            errors.keywords = "The keywords field is required.";
        }

        if (file && FileSize > 2) {
            errors.image = "File size exceeds 2 MB";
        } 
        
        if (file && !this.isImage(FileName)) {
            errors.image = "Please select a valid image file.";
        }

        if(fields.status != "coming_soon" && !fields.video){
            formIsValid = false;
            errors.video = "The video field is required.";
        }  
        
        if(fields.status != "coming_soon" && !fields.video){
            formIsValid = false;
            errors.video = "The video field is required.";
        }      
        
        if(fields.status != "coming_soon" && this.state.showCertiDiv ===  true && !fields.certificate_title){
            formIsValid = false;
            errors.certificate_title = "Please enter certification description.";
        } 
        
        if(fields.status != "coming_soon" && this.state.showCertiDiv ===  true && fields.certificate_title  && fields.certificate_title.length > 200){
            formIsValid = false;
            errors.certificate_title = "Please limit certification description by 200 charecters.";
        } 
        
        if (fields.status != "coming_soon" && this.state.showCertiDiv ===  true && cfile && cFileSize > 2) {
            errors.certificate_image = "File size exceeds 2 MB";
        } 
        
        if (fields.status != "coming_soon" && this.state.showCertiDiv ===  true && cfile && !this.isImage(cFileName)) {
            errors.certificate_image = "Please select a valid image file.";
        }
        
        this.setState({errors: errors});
        return formIsValid;
    }    

    handleSubmit = e => { 
        e.preventDefault();
        const formData = new FormData(e.target);       
        if(this.handleValidation()){  
            let errors = {};  
            let taglist = this.state.tags;        
            if(this.state.selectedFile)
            {
                formData.append(
                    'course_image',
                    this.state.selectedFile,
                    this.state.selectedFile.name
                )
            }
            formData.append('description',this.state.item.description);
            formData.append('category_id',this.state.item.category);
            formData.append('keywords',taglist.length > 0 ? taglist.join(',') : '');
            if(this.state.certificateFile)
            {
                formData.append(
                    'certificate_image',
                    this.state.certificateFile,
                    this.state.certificateFile.name
                )
                
            }
            formData.append('certificate_title',this.state.item.certificate_title);
            formData.append('certification',this.state.showCertiDiv);
            formData.append('popular',this.state.item.popular);
            formData.append('status',this.state.item.status);
            createCourse(formData)
            .then(response => {
                this.props.history.push("/admin/courses");                
            })
            .catch(errors => {
                switch (errors.response.status) {
                    case 422:
                        this.setState({ errors: errors.response.data.error });
                        break;
                    default:
                        this.context.state.handelError(errors);
                        break;
                }
            });

            //console.log(formData.values(),this.state.item);
        }        
    };    

    componentDidMount() {          
        catList()
            .then(res => {
                this.setState({ categories: res.data });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });

        this.setState({ statusList: [
            {"id":'active',"value":'active',"name":'Active',"label":'Active'},
            {"id":'draft',"value":'draft',"name":'Draft',"label":'Draft'},
            {"id":'coming_soon',"value":'coming_soon',"name":'Coming Soon',"label":'Coming Soon'},
        ] }); 
    }
    render() {
        return (
            <Fragment>
                <Header></Header>

                <div className="main-content mt-6">
                    <div className="container mt-3">
                        <div className="row justify-content-center">
                            <div
                                id="formModal"
                                className="col-12 col-lg-10 col-xl-8"
                            >
                                <div className="header">
                                    <div className="header-body">
                                        <div className="row align-items-center">
                                            <div className="col">
                                                <h6 className="header-pretitle">
                                                    Add Course
                                                </h6>
                                                <h1 className="header-title">
                                                    Publish a new course listing
                                                </h1>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <form data-select2-id="14" onSubmit={this.handleSubmit}>    
                                <div className="form-group">
                                        <label htmlFor="category">Select Category</label>
                                        <Select 
                                                styles={{
                                                    control: base => ({
                                                        ...base,
                                                        "&:hover": {
                                                            borderColor:
                                                                "#1cd2ad",
                                                            boxShadow: "none"
                                                        },
                                                        "&": {
                                                            borderColor:
                                                                "#d2ddec",
                                                            boxShadow: "none"
                                                        }
                                                    }),
                                                    dropdownIndicator: base => ({
                                                        ...base,
                                                        color: "inherit"
                                                    }),
                                                    singleValue: base => ({
                                                        ...base,
                                                        color: "inherit"
                                                    })
                                                }}
                                                name="category"
                                                id="category" 
                                                value={this.state.item.category}   
                                                placeholder = {this.state.selectedcat}                                            
                                                onChange={
                                                    this
                                                        .handlecatSelectChange
                                                }                                              
                                                options={
                                                    this.state.categories
                                                }
                                            ></Select>
                                        {this.state.errors.category ? (
                                            <div className="invalid-feedback">
                                                {this.state.errors.category}
                                            </div>
                                        ) : null}
                                       <a onClick={this.toggleCreate}>Add New Category</a>
                                    </div>                                
                                    <div className="form-group">
                                        <label htmlFor="title">Title</label>
                                        <input
                                            id="title"
                                            name="title"
                                            onChange={this.onChange}
                                            value={this.state.item.title || '' }
                                            type="text"
                                            className="form-control"
                                        />
                                        {this.state.errors.title ? (
                                            <div className="invalid-feedback">
                                                {this.state.errors.title}
                                            </div>
                                        ) : null}
                                    </div>
                                    <div className="form-group mb-6">
                                        <label
                                            className="mb-1"
                                            htmlFor="description"
                                        >
                                            Description
                                        </label>
                                        <small className="form-text text-muted">
                                                Describe course requirements.
                                        </small>
                                        <Quill
                                            style={{
                                                height: "200px"
                                            }}
                                            onChange={this.handleQuillChange}
                                            value={
                                                this.state.item
                                                    .description || ""
                                            }
                                        ></Quill>

                                        {this.state.errors.description ? (
                                            <div className="invalid-feedback">
                                                {this.state.errors.description}
                                            </div>
                                        ) : null}
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="title">Keywords</label>
                                        {/* <input
                                            id="keywords"
                                            name="keywords"
                                            onChange={this.onChange}
                                            value={this.state.item.keywords || '' }
                                            type="text"
                                            className="form-control"
                                            placeholder=""
                                        /> */}
                                        <div className="input-tag">
                                            <ul className="input-tag__tags">
                                            { this.state.tags.map((tag, i) => (
                                                <li key={tag}>
                                                {tag}
                                                <button type="button" onClick={() => { this.removeTag(i); }}>+</button>
                                                </li>
                                            ))}
                                                <li className="input-tag__tags__input"><input type="text" className="form-control" onKeyDown={this.inputKeyDown} ref={c => { this.tagInput = c; }} /></li>
                                            </ul>
                                        </div>
                                        
                                        {this.state.errors.keywords ? (
                                            <div className="invalid-feedback">
                                                {this.state.errors.keywords}
                                            </div>
                                        ) : null}
                                    </div>        
                                    <div className="form-group row">
                                        <div className="col-12 col-md-4">
                                        
                                            <div className="form-group">
                                                <label htmlFor="payout">
                                                Course Fee (Basic)
                                                </label>
                                                <div className="input-group mb-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text">$</span>
                                                    </div>
                                                    <input
                                                        id="payout"
                                                        name="payout"
                                                        onChange={this.onChange}
                                                        onBlur={this.handleBlur}
                                                        type="number"
                                                        value={
                                                            this.state.item.payout || ''
                                                        }
                                                        className="form-control"
                                                    />
                                                </div>
                                                
                                                {this.state.errors.payout ? (
                                                    <div className="invalid-feedback">
                                                        {
                                                            this.state.errors
                                                                .payout
                                                        }
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-4">
                                        
                                            <div className="form-group">
                                                <label htmlFor="payout_plus">
                                                Course Fee (Plus)
                                                </label>
                                                <div className="input-group mb-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text">$</span>
                                                    </div>
                                                    <input
                                                        id="payout_plus"
                                                        name="payout_plus"
                                                        onChange={this.onChange}
                                                        onBlur={this.handleBlur}
                                                        type="number"
                                                        value={
                                                            this.state.item.payout_plus || ''
                                                        }
                                                        className="form-control"
                                                    />
                                                </div>
                                                
                                                {this.state.errors.payout_plus ? (
                                                    <div className="invalid-feedback">
                                                        {
                                                            this.state.errors
                                                                .payout_plus
                                                        }
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="duration">Duration</label>
                                                <input
                                                    id="duration"
                                                    name="duration"
                                                    onChange={this.onChange}
                                                    value={this.state.item.duration || '' }
                                                    type="text"
                                                    className="form-control"
                                                    placeholder=""
                                                />
                                                {this.state.errors.duration ? (
                                                    <div className="invalid-feedback">
                                                        {this.state.errors.duration}
                                                    </div>
                                                ) : null}
                                            </div> 
                                        </div>
                                    </div>                                   
                                    
                                    <div className="form-group row">
                                        <div className="col-12 col-md-6">
                                        
                                        <div className="form-group">
                                            <label htmlFor="image">Course Image</label>
                                            <input
                                                        id="image"
                                                        name="image"                                           
                                                        onChange={this.fileChangedHandler}
                                                        type="file"
                                                        className="form-control"
                                                    />

                                                    {this.state.errors.image ? (
                                                        <div className="text-danger">
                                                            {this.state.errors.image}
                                                        </div>
                                                    ) : null}
                                            
                                        </div>
                                        </div>
                                        <div className="col-12 col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="video">Course Video (iframe)</label>
                                                <input
                                                    id="video"
                                                    name="video"
                                                    onChange={this.onChange}
                                                    value={this.state.item.video || '' }
                                                    type="text"
                                                    className="form-control"
                                                    placeholder=""
                                                />
                                                {this.state.errors.video ? (
                                                    <div className="invalid-feedback">
                                                        {this.state.errors.video}
                                                    </div>
                                                ) : null}
                                            </div> 
                                        </div>
                                    </div>  
                                    <div className="form-group">
                                            <label htmlFor="status">Status</label>
                                            <Select defaultValue={{ label: "Active", value: "active" }}
                                                    styles={{
                                                        control: base => ({
                                                            ...base,
                                                            "&:hover": {
                                                                borderColor:
                                                                    "#1cd2ad",
                                                                boxShadow: "none"
                                                            },
                                                            "&": {
                                                                borderColor:
                                                                    "#d2ddec",
                                                                boxShadow: "none"
                                                            }
                                                        }),
                                                        dropdownIndicator: base => ({
                                                            ...base,
                                                            color: "inherit"
                                                        }),
                                                        singleValue: base => ({
                                                            ...base,
                                                            color: "inherit"
                                                        })
                                                    }}
                                                    name="status"
                                                    id="status"
                                                    placeholder="Select"
                                                    onChange={
                                                        this
                                                            .handleStatusSelectChange
                                                    }
                                                    options={
                                                        this.state.statusList
                                                    }
                                                ></Select>
                                            {this.state.errors.status ? (
                                                <div className="invalid-feedback">
                                                    {this.state.errors.status}
                                                </div>
                                            ) : null}
                                            
                                        </div>  
                                    <input
                                            checked={this.state.showCertiDiv}
                                            onChange={this.handleCheck}
                                            className="react-switch-checkbox"                                            
                                            type="checkbox"
                                        />
                                       <label htmlFor="Certification" className="ml-1 mr-2">Certification</label>
                                    { this.state.showCertiDiv ? 
                                    <div className="form-group row">
                                        
                                        <div className="col-12 col-md-6">
                                        <label htmlFor="certificate_title">Certificate Description</label>
                                        <input
                                            id="certificate_title"
                                            name="certificate_title"
                                            onChange={this.onChange}
                                            value={this.state.item.certificate_title || '' }
                                            type="text"
                                            className="form-control"
                                        />
                                        {this.state.errors.certificate_title ? (
                                            <div className="invalid-feedback">
                                                {this.state.errors.certificate_title}
                                            </div>
                                        ) : null}
                                    </div>
                                        <div className="col-12 col-md-6">                                        
                                            <div className="form-group">
                                                <label htmlFor="image">Certificate Image</label>
                                                <input
                                                            id="certificate_image"
                                                            name="certificate_image"                                           
                                                            onChange={this.certificateChangedHandler}
                                                            type="file"
                                                            className="form-control"
                                                        />

                                                        {this.state.errors.certificate_image ? (
                                                            <div className="text-danger">
                                                                {this.state.errors.certificate_image}
                                                            </div>
                                                        ) : null}
                                                
                                            </div>
                                        </div>
                                        
                                    </div>     
                                    : '' }
                                        <br/>
                                        <input
                                            checked={this.state.item.popular}
                                            onChange={this.handlePropCheck}
                                            className="react-switch-checkbox"                                            
                                            type="checkbox"
                                        />
                                       <label htmlFor="Certification" className="ml-1">Popular</label> 
                                         
                                    <hr className="mt-5 mb-5" />
                                    <button className="newJob btn btn-block btn-primary text-white">Publish Course</button> 
                                    {/* <a
                                        onClick={() =>
                                            this.handleSubmitJob("active")
                                        }
                                        name="save"
                                        className="newJob btn btn-block btn-primary text-white"
                                    >
                                        Post course listing
                                    </a> */}
                                    <div className=" btn-block center-text  mb-6 mt-3 d-flex justify-content-center">
                                        <Link
                                            to={`/admin/courses`}
                                            className="btn btn-link text-muted"
                                        >
                                            Cancel
                                        </Link>
                                       
                                    </div>
                                </form>    
                                {this.state.createM === true ? (
                                    <CategoryModel 
                                        createM={this.createM}
                                        hideCreate={this.toggleCreate} 
                                        listCats = {this.listCats}                                                                           
                                    ></CategoryModel>
                                ) : null}                                    
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

CourseCreate.contextType = AppContext;
export default CourseCreate;



// WEBPACK FOOTER //
// ./src/components/admin/courses/Create.js